import { render, staticRenderFns } from "./ErpHeaderLoggedIn.vue?vue&type=template&id=3db01a77"
import script from "./ErpHeaderLoggedIn.vue?vue&type=script&lang=js"
export * from "./ErpHeaderLoggedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports